module.exports = function(v) {
  return v === null;
};



//////////////////
// WEBPACK FOOTER
// ./~/vinyl/lib/isNull.js
// module id = 4052
// module chunks = 0